/**
 * Historial de cajas: la lista con su paginación (ver CashboxSessionsList).
 */

import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

import { t } from '@/i18n'
import { Button } from '@/components/ui/button'
import { CashboxSessionsList } from './CashboxSessionsList'

export function CashboxHistoryPage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Button
          variant="ghost"
          size="icon"
          className="h-10 w-10 shrink-0"
          onClick={() => navigate('/cashbox')}
          aria-label={t('common.back')}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <h1 className="text-xl md:text-3xl font-bold">{t('cashbox.history')}</h1>
      </div>
      <CashboxSessionsList />
    </div>
  )
}
